import {GetterTree} from "vuex";
import {RootState} from "@service/store/types/RootState";
import {EventsState} from "@service/store/types/EventsState";
import { ArrayHelpers } from "@common/ArrayHelpers";
import { Element } from "@api/models/Element";
import { ServiceName } from "../services/types";

const getters: GetterTree<EventsState, RootState> = {
    selectedEvent: state => {
        return state.list.find(item => item.id == state.selected);
    },
    exhibitionIds : (state) => (eventId: string) => {
        return state.list.find(item => item.id == eventId)?.partnerIds || []
    },
    sortedListByEndDateDesc(state) {
        return state.list.sort((a, b) => {
            if (a.endAt < b.endAt) {
                return 1;
            }
            if (a.endAt > b.endAt) {
                return -1
            }
            return 0;
        });
    },
    selectedEventViewParam: (state, getter) => (key: string, defaultValue: any = null) => {
        const event = getter['selectedEvent'];
        if (event) {
            return event?.viewParams?.[key] ?? defaultValue;
        }
        return defaultValue;
    },
    selectedEventSpeakers: (_, getter) => {
        const event = getter['selectedEvent'];
        if (event) {
            return event?.speakers ?? [];
        }
        return [];
    },
    isMeetingsEnabled: (state, getter, rootState, rootGetters) => {
        const serviceIsEnabled = rootGetters['services/serviceIsEnabled'](ServiceName.meetings, true);

        if (!serviceIsEnabled) {
            return serviceIsEnabled;
        }

        const params = getter['selectedEventViewParam']('meetings', {});
        return !!(params?.enabled);
    },
    allowMeetingWithSpeakers: (_, getter) => {
        const participantsOptions = getter['selectedEventViewParam']('participants');
        if (participantsOptions?.allowMeetingWithSpeakers === false) {
            return false;
        }
        return true;
    },
    allowChatWithSpeakers: (_, getter) => {
        const participantsOptions = getter['selectedEventViewParam']('participants');
        if (participantsOptions?.allowChatWithSpeakers === false) {
            return false;
        }
        return true;
    },
    //ограничения для партнеров во время раннего доступа
    isRestrictedPartner(state, getters, rootState, rootGetters) {

        const restrictedPartnersGroupIds = getters["selectedEventViewParam"]("restrictedPartners")?.groupIds || [];

        if (restrictedPartnersGroupIds.length > 0) {
            const userGroupIds = rootGetters['groupIds'];

            return Boolean(ArrayHelpers.intersect(restrictedPartnersGroupIds, userGroupIds).length);
        }
        else {
            return false;
        }
    },
    //доступно ли использование чата
    isChatAllowed(state, getters, rootState, rootGetters) {

        const isRestrictedPartner = getters['isRestrictedPartner'];

        if (isRestrictedPartner) {
            return false;
        }

        const userGroupIds = rootGetters['groupIds'];
        const chatParams = getters['selectedEventViewParam']('chat', null);

        if (chatParams?.groupIds) {
            return !!ArrayHelpers.intersect(userGroupIds, chatParams?.groupIds).length;
        }

        return true;
    },
    eventAvailable: (state) => (eventId: string) => {
        return state.list.some((event) => event.id === eventId);
    },
    tagsSchemaId: (state, getters) => (schemaId: string) => {
        const catalogs = getters['selectedEventViewParam']('catalog');
        if (catalogs) {
            return catalogs.filter((item: Record<string, any>) => item.schemaId === schemaId)?.[0]?.refs?.tagsIds;
        }
        return null;
    },
    selectedEventExhibitions: (state): Record<string, Element> => {
        if (state.selected && state.exhibitions.list && state.exhibitions.list[state.selected]) {
            return state.exhibitions.list[state.selected];
        }

        return {};
    }
};

export {getters}
